import React from "react";
import { useState } from "react";
import logo from "../../assets/images/UpdatedLogo.png";
import individualLogo from "../../assets/app/Individual Logo.svg";
import teamLogo from "../../assets/app/Mask group.svg";
import { Layout, theme, Menu, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

const { Sider } = Layout;

// Add to LeftBar props:
interface VerticalNavigationBarProps {
  menuItems: { key: string; title: string; path: string }[];
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const LeftBar: React.FC<VerticalNavigationBarProps> = ({ menuItems }) => {
  const location = useLocation();
  let selectedKey = "1";
  if (
    location.pathname === "/review/pm/team" ||
    location.pathname === "/review/level1/team" ||
    location.pathname === "/review/level2/team" ||
    location.pathname === "/review/stack/team" ||
    location.pathname === "/review/final/team" ||
    location.pathname === "/admin/view/team"
  ) {
    selectedKey = "2";
  }
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // Custom style for menu items
  const menuItemStyle: React.CSSProperties = {
    height: "100px",
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Hamburger for mobile */}
      <Button
        className="leftbar-mobile-toggle"
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          display: "none",
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 1100,
        }}
      />
      <Sider
        width={200}
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          background: "#481558",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 1000,
          transition: "all 0.2s",
        }}
        className={collapsed ? "leftbar-collapsed" : ""}
        breakpoint="md"
        onBreakpoint={(broken) => setCollapsed(broken)}
      >
        <div className="demo-logo-vertical" style={{ background: "#481558" }} data-tour="sidebar-nav" />
        <img
          src={logo}
          alt="Aptean Logo"
          style={{
            width: "40%",
            height: "10%",
            marginTop: "12%",
            marginLeft: "28%",
            marginBottom: "5%",
          }}
        />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{ backgroundColor: "#481558" }}
        >
          <Menu.Item key="1" style={menuItemStyle} data-tour="individual-awards">
            <div>
              <img
                src={individualLogo}
                alt="Individual Logo"
                style={{ width: "60%", height: "50%", marginLeft: "15px" }}
                data-tour="individual-icon"
              />
              <div style={{ color: "#fff", marginTop: "-20px" }}>
                Individual Award
              </div>
            </div>
            <Link to={menuItems[0].path}></Link>
          </Menu.Item>
          <Menu.Item key="2" style={menuItemStyle} data-tour="team-awards">
            <div>
              <img
                src={teamLogo}
                alt="Team Logo"
                style={{ width: "80%", height: "50%" }}
                data-tour="team-icon"
              />
              <div style={{ color: "#fff", marginTop: "-20px" }}>
                Team Award
              </div>
            </div>
            <Link to={menuItems[1].path}></Link>
          </Menu.Item>
        </Menu>
      </Sider>
      {/* Responsive styles */}
      <style>
        {`
        @media (max-width: 768px) {
          .ant-layout-sider {
            position: fixed !important;
            left: 0 !important;
            top: 0 !important;
            height: 100vh !important;
            z-index: 1000 !important;
            width: 200px !important;
            min-width: 0 !important;
            max-width: 80vw !important;
            transition: all 0.2s;
          }
          .leftbar-mobile-toggle {
            display: block !important;
          }
          .ant-layout-sider.leftbar-collapsed {
            left: -200px !important;
          }
        }
        @media (max-width: 480px) {
          .ant-layout-sider {
            width: 140px !important;
            max-width: 90vw !important;
          }
        }
        `}
      </style>
    </Layout>
  );
};

export default LeftBar;